import DianXin from "./DianXin";

export * from "./DianXin";
export * from "./DianXin.model";
export * from "../Tiles";

export default DianXin;
